import { Routes } from '@angular/router';
import { DrevSyntheseComponent } from './drev-synthese.component';

export const DREV_SYNTHESE_ROUTES: Routes = DrevSyntheseComponent.routes;
